<template>
    <div id="profile-page">
        <div class="page-heading">
            <h2 class="display-4 montserrat-bold mb-0">Vouchers</h2>
            <div class="mt--2 heading-small">Booking Discount Vouchers</div>
        </div>

        <div class="bg-white shadow-reg list-container card-list-container">
            <paginated-section class="card-list" :fetch-link="voucherFetchLink" :params="vouchersParams" paginate-path="data.result.vouchers" ref="list" simplified>
                <template slot="loading">
                    <h3 class="text-muted m-0 pt-5 pb-5 text-center">
                        <i class="fas fa-spin fa-spinner mr-2"></i> Loading vouchers
                    </h3>
                </template>
                <template slot="empty">
                    <h3 class="text-muted m-0 pt-5 pb-5 text-center">No vouchers were found</h3>
                </template>
                <template slot="body" slot-scope="{ record }">
                    <vocuher-list-item :voucher="record" />
                </template>

            </paginated-section>
        </div>

    </div>
</template> 
<script>
import '@styles/table.css';
import VocuherListItem from "./VocuherListItem";
import { route, get } from "@utils/network";

export default {
    name: "VocuherListPage",

    components: { VocuherListItem },

    data: () => ({
        voucherFetchLink: route("vouchers/customer"),
        vouchersParams: {
            is_strict: true,
        }
    }),

    mounted() {
        this.$emit("mounted");
    }
}
</script>
<style lang="css" scoped>
    .list-container .list-content-item {
        margin-bottom: 0.5rem !important;
        padding: 2rem 1.5rem 2rem !important;
        border-bottom: 1px solid rgba(0,0,0,0.1);
    }
</style>